(function () {
  if (window.containerBarraAutoplay) {
    window.containerBarraAutoplay.init();
    return;
  }

  const INTERVAL = 3000;

  function getStep(slider) {
    const slides = Array.from(slider.querySelectorAll('.slider__slide, .grid__item')).filter(
      (slide) => slide.clientWidth > 0
    );

    if (slides.length > 1) {
      return Math.max(slides[1].offsetLeft - slides[0].offsetLeft, slides[0].clientWidth);
    }

    return slider.clientWidth;
  }

  function canScroll(slider) {
    return slider.scrollWidth > slider.clientWidth + 2;
  }

  function next(slider) {
    if (document.hidden || !canScroll(slider)) return;

    const atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 2;

    slider.scrollTo({
      left: atEnd ? 0 : slider.scrollLeft + getStep(slider),
      behavior: 'smooth',
    });
  }

  function bind(container) {
    if (!container || container.dataset.autoplayBound === 'true') return;

    const slider = container.querySelector('.slider');
    if (!slider) return;

    container.dataset.autoplayBound = 'true';
    let intervalId = window.setInterval(() => next(slider), INTERVAL);

    function restart() {
      window.clearInterval(intervalId);
      intervalId = window.setInterval(() => next(slider), INTERVAL);
    }

    container.addEventListener('pointerdown', restart);
    container.addEventListener('focusin', restart);
  }

  function init(root) {
    const scope = root || document;
    scope.querySelectorAll('.container-barra').forEach(bind);
  }

  window.containerBarraAutoplay = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
